// Phone number formatting utilities

// Strip all non-digit characters from phone number
export const stripPhone = (phone) => {
  if (!phone) return '';
  return phone.replace(/\D/g, '');
};

// Strip leading US country code "1" if present, returning 10-digit number
const stripCountryCode = (digits) => {
  if (digits.length === 11 && digits.startsWith('1')) {
    return digits.slice(1);
  }
  return digits;
};

// Format phone number for display (XXX.XXX.XXXX)
export const formatPhoneDisplay = (phone) => {
  let digits = stripPhone(phone);
  digits = stripCountryCode(digits);
  if (digits.length === 0) return '';
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 10)}`;
};

// Format phone number as user types (with dots)
export const formatPhoneInput = (value) => {
  let digits = stripPhone(value);
  digits = stripCountryCode(digits);
  if (digits.length === 0) return '';
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 10)}`;
};

// Handle phone input change - returns formatted value for display and digits for storage
export const handlePhoneChange = (value) => {
  let digits = stripPhone(value);
  digits = stripCountryCode(digits);
  const formatted = formatPhoneInput(digits);
  return {
    formatted,
    digits: digits.slice(0, 10), // Limit to 10 digits after stripping country code
  };
};
